export default __webpack_public_path__ + "static/media/closet4-2048w.3b3f81cd.webp";